"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStartTime = void 0;
// Disregard last position if it was at the end credits (decimal number between 0-1)
const RESTART_THRESHOLD = 0.95;
function getStartTime({ streamInfo, bookmarks, durationInMilliseconds, } = {}) {
    const lastViewedOffset = bookmarks === null || bookmarks === void 0 ? void 0 : bookmarks.lastViewedOffset;
    if (streamInfo &&
        !streamInfo.live &&
        lastViewedOffset &&
        durationInMilliseconds) {
        if (lastViewedOffset / durationInMilliseconds < RESTART_THRESHOLD) {
            return lastViewedOffset / 1000;
        }
    }
    return;
}
exports.getStartTime = getStartTime;
//# sourceMappingURL=data.js.map